module.exports = __webpack_public_path__ + "static/media/cyber-security-small.f6b7b4e4.jpg";